import parseJwt from './parseJWT';

const getDataFromAccessToken = (accessToken: string) => {
  return {
    storeId: parseJwt(accessToken).entityId,
  };
};

export default getDataFromAccessToken;
